"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../hooks");
exports.ContentImportPanelSearchContentButton = () => {
    const { contentItemsResult, isLoadingContentItems, showSearch, } = hooks_1.useContentImportPanelData();
    const { setState } = hooks_1.useContentImportPanelUpdate();
    return (react_2.default.createElement(react_1.OsmosysDiv, { osysName: "ContentImportPanel.toolbar.inner", flexColCentered: true },
        react_2.default.createElement(react_1.OsmosysButton, { osysName: "ContentImportPanel.search", osysIcon: showSearch ? 'searchClose' : 'search', osysStyle: "navLink", tooltip: showSearch ? 'Close search' : 'Search content items', className: "p-1", disabled: !contentItemsResult.data || isLoadingContentItems, onClick: () => {
                setState({
                    showSearch: !showSearch,
                });
            } })));
};
//# sourceMappingURL=SearchContentButton.js.map